<template>
  <el-select
    :value="sipServerId"
    :size="size"
    placeholder="Выберите SIP-сервер"
    style="width: 100%"
    filterable
    :loading="loading && !sip_servers.length"
    @change="change"
    clearable
    @clear="clear"
  >
    <el-option
      v-for="server in sip_servers"
      :key="server.id_sip_server"
      :label="server.ip"
      :value="server.id_sip_server"
    />
  </el-select>
</template>

<script>
import { ApiService } from "@/api";

export default {
  name: "SelectSipServer",
  model: {
    prop: "sip-server-id",
    event: "change",
  },
  props: {
    sipServerId: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      loading: true,
      sip_servers: [],
    };
  },
  created() {
    ApiService.sip_servers
      .getList()
      .then((payload) => {
        this.sip_servers = payload.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    change(id) {
      //const selectedSipServerId = this.sip_servers.find((t) => t.id_sip_server === id).id_sip_server;
      this.$emit("change", id);
    },
    clear() {
      this.$emit("clear");
    }
  },
};
</script>
